<template>
    <div>
      <!-- Desktop view -->
      <v-container v-if="$vuetify.breakpoint.mdAndUp" fluid class="chat-container pa-0">
        <v-row no-gutters>
          <!-- Chat list -->
          <v-col cols="4">
            <chat-list @select-chat="selectChat" />
          </v-col>
  
          <!-- Chat messages -->
          <v-col cols="8">
            <chat-messages />
          </v-col>
        </v-row>
      </v-container>
  
      <!-- Mobile view -->
      <div v-else>
        <!-- Chat list -->
        <chat-list v-if="!$store.state.chat.currentChat" @select-chat="openChatDialog" />
  
        <!-- Full-screen dialog for chat messages -->
        <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="closeChatDialog">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-toolbar-title>{{ currentChatName }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <chat-messages />
          </v-card>
        </v-dialog>
      </div>
    </div>
  </template>
  
  <script>
  import ChatList from '@/components/ChatList.vue';
  import ChatMessages from '@/components/ChatMessages.vue';
  
  export default {
    name: 'ChatInterface',
    components: {
      ChatList,
      ChatMessages
    },
    data() {
      return {
        dialog: false
      };
    },
    computed: {
      currentChatName() {
        const currentChat = this.$store.state.chat.chats.find(
          chat => chat.id === this.$store.state.chat.currentChat
        );
        return currentChat ? currentChat.name : '';
      }
    },
    methods: {
      selectChat(chatId) {
        this.$store.dispatch('chat/selectChat', chatId);
      },
      openChatDialog(chatId) {
        this.selectChat(chatId);
        this.dialog = true;
      },
      closeChatDialog() {
        this.$store.dispatch('chat/selectChat', null);
        this.dialog = false;
      }
    }
  };
  </script>
  
  <style scoped>
  .chat-container {
    height: calc(100vh - 64px); /* Adjust this value based on your app bar height */
  }
  </style>